module.exports = __webpack_public_path__ + "static/blog-01-3818485b4785a0924ff84eb49819cebd.jpg";